import authInstance from "../Interceptor";

export const ViewAllConSumptionEffect = (wholesaler_id, pageNo, search_key) => {
  return authInstance.get(
    `cproducts/shots/consumptionShotsList?wholesaler_id=${wholesaler_id}&pageNo=${pageNo}&search_key=${search_key}&pagesize=10&pagination_required=true`
  );
};

// export const TransactionsEffect = (wholesaler_id) => {
//   return authInstance.get(
//     `/cproducts/shots/consumptionShotsList?wholesaler_id=${wholesaler_id}`
//   );
// }

export const WholesalerMonthReportEffect = (pageNo) => {
  return authInstance.get(
    `/reports/reportWholesalerlistMonthWise?pageNo=${pageNo}&pagesize =10&pagination_required=true`
  );
};

export const WholesalerWeekReportEffect = (pageNo) => {
  return authInstance.get(
    `/reports/reportWholesalerlistWeekWise?pageNo=${pageNo}&pagesize =10&pagination_required=true`
  );
};

export const WholesalerDayReportEffect = (pageNo) => {
  return authInstance.get(
    `/reports/reportWholesalerlistDateWise?pageNo=${pageNo}&pagesize =10&pagination_required=true`
  );
};

// export const WholesalerReportEffect = ({ pageNo, start_date, end_date }) => {
//   return authInstance.get(
//     `/stripe/reportWholesalerlist?pageNo=${pageNo}&pagesize=10&pagination_required=true&start_date=${start_date}&end_date=${end_date}`
//   );
// };

export const WholesalerMonthDateSearchReportEffect = ({
  pageNo,
  start_date,
  end_date,
}) => {
  return authInstance.get(
    `/reports/reportWholesalerlistMonthWise?pagesize=10&pagination_required=true&start_date=${start_date}&end_date=${end_date}&pageNo=${pageNo}`
  );
};

export const WholesalerWeekDateSearchReportEffect = ({
  pageNo,
  start_date,
  end_date,
}) => {
  return authInstance.get(
    `/reports/reportWholesalerlistWeekWise?pagesize=10&pagination_required=true&start_date=${start_date}&end_date=${end_date}&pageNo=${pageNo}`
  );
};

export const WholesalerDayDateSearchReportEffect = ({
  pageNo,
  start_date,
  end_date,
}) => {
  return authInstance.get(
    `/reports/reportWholesalerlistDateWise?pagesize=10&pagination_required=true&start_date=${start_date}&end_date=${end_date}&pageNo=${pageNo}`
  );
};

export const SearchWholesalerReportEffect = () => {
  // return authInstance.get(`/reports/reportWholesalerlist`);
    return authInstance.get(`/reports/reportWholesalerlistDateWise`);

};

// export const SearchConsumptionEffect = () => {
//   return authInstance.get(
//     `/cproducts/shots`
//   );
// };
// export const SearchTransactionsEffect = () => {
//   return authInstance.get(
//     `/cproducts/shots`
//   );
// };
